(() => {
  if (window.LmdlFooterPremiumLoaded) return;
  window.LmdlFooterPremiumLoaded = true;

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const selector = '[data-lmdl-footer-main]';

  const syncFooter = (footer) => {
    if (!footer) return;
    const useAccordions = footer.dataset.mobileAccordion === 'true';
    footer.querySelectorAll('[data-lmdl-footer-details]').forEach((details) => {
      if (!mobileQuery.matches || !useAccordions) {
        details.open = true;
      } else if (details.dataset.userToggled !== 'true') {
        details.open = details.dataset.openMobile === 'true';
      }
    });
  };

  const initFooter = (footer) => {
    if (!footer || footer.dataset.lmdlFooterReady === 'true') return;
    footer.dataset.lmdlFooterReady = 'true';

    footer.querySelectorAll('[data-lmdl-footer-details]').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!mobileQuery.matches || footer.dataset.mobileAccordion !== 'true') {
          if (!details.open) window.requestAnimationFrame(() => { details.open = true; });
        } else {
          details.dataset.userToggled = 'true';
        }
      });
    });

    syncFooter(footer);
  };

  const initAll = (root = document) => {
    if (root.matches?.(selector)) initFooter(root);
    root.querySelectorAll?.(selector).forEach(initFooter);
  };

  const syncAll = () => {
    document.querySelectorAll(selector).forEach((footer) => {
      footer.querySelectorAll('[data-lmdl-footer-details]').forEach((details) => delete details.dataset.userToggled);
      syncFooter(footer);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', syncAll);
  else mobileQuery.addListener?.(syncAll);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const details = event.target.closest?.('[data-lmdl-footer-details]');
    if (details) details.open = true;
  });
})();
